module.exports = __webpack_public_path__ + "static/media/Heatran_gaussian2.8e1931f3.png";